<template>
  <div class="follow-shop-index">
    <div class="header-tabs">
      <div class="header-tab"><span class="item" :class="{active: thisComponent==='ShenggouList'}" @click="thisComponent='ShenggouList'">省购</span></div>
      <div class="header-tab"><span class="item" :class="{active: thisComponent==='KnowList'}" @click="thisComponent='KnowList'">微课</span></div>
    </div>

    <component :is="thisComponent"></component>

  </div>
</template>

<script>
import KnowList from './components/know'
import ShenggouList from './components/shenggou'
export default {
  components: {
    KnowList,
    ShenggouList,
  },
  data() {
    return {
      thisComponent: 'ShenggouList',
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.follow-shop-index{
  .header-tabs{
    display: flex;height: 43px;
    .header-tab{
      flex: 1;height: 42px;
      display: inline-flex;justify-content: center;align-items: center;
      font-size: 16px;color: #333;
      .item{
        display: inline-flex;align-items: center;height: 100%;margin: 0 12px;
        border-bottom: 1px solid transparent;
        &.active{
          border-bottom: 1px solid #1585f3;color: #1585f3;
        }
      }

    }
  }
}
</style>